export enum SortDirections {
    Ascending = "Asc",
    Descending = "Des"
}